import React from 'react';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { useStyles } from '../Dashboard.styles';
import { DashboardType } from '../Dashboard.types';
import { SwitchDashboardTypeButtons } from './SwitchDashboardTypeButtons/SwitchDashboardTypeButtons';

export const DashboardHeader: React.FC<{
  isEmptyResult: boolean;
  activeDashboardType: DashboardType;
  onSwitchDashboardType: (activeDashboardType: DashboardType) => void;
}> = ({ isEmptyResult, onSwitchDashboardType, activeDashboardType }) => {

  const styles = useStyles();
  useDocumentTitle('Sesje Oceniania');

  return (
    <div className={styles.dashboardContainer}>
        <div className={styles.buttonHeader}>
          <SwitchDashboardTypeButtons activeDashboardType={activeDashboardType} onSwitchDashboardType={onSwitchDashboardType} />
        </div>
      <div style={{ height: 20 }}></div>
    </div>
  );
};
